import { render, staticRenderFns } from "./HbBenefit.vue?vue&type=template&id=ece28494&scoped=true&"
import script from "./HbBenefit.vue?vue&type=script&lang=js&"
export * from "./HbBenefit.vue?vue&type=script&lang=js&"
import style0 from "./HbBenefit.vue?vue&type=style&index=0&id=ece28494&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ece28494",
  null
  
)

export default component.exports